<!--
 * @Author: your name
 * @Date: 2020-07-22 16:44:22
 * @LastEditTime: 2021-01-07 14:03:23
 * @LastEditors: Please set LastEditors
 * @Description: 填空题  E 
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\question\title\correction_title.vue
--> 
<template>
  <div class="title">
    <div class="question_type" :id="'anchor' + question.id">
      <div class="id">{{question.originalName}}</div>
      <div class="cricle"></div>
      <div class="mask"></div>
      <div class="name">
        <!-- 题型 : {{question_type}}
        <span class="score">分数 : {{question.score}}</span> -->

        <!-- 字号功能 -->
        <!-- <div class="demo-input-suffix divs" v-if="!isComposite">
          <span class="text">字号：</span>
          <el-select popper-class="font-set" v-model="fontSize" placeholder="请选择" @change="selectFontSize"> 
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div> -->
      </div>
    </div>

    <div class="question_content">
      
      <!-- 当为选择题时,要展示选项 -->
        <div class="topic" :style="`font-size:${setFontSize}px`" :id="'question_content_'+question.id">
          <div class="text" v-html="manipulateDataOptions(manipulateData(questionStem(question.stem, question.id)))"></div>
        </div>
        <ul class="options">
          <li
            class="option text"
            v-for="(option,index) in question.gkQuestionOptions"
            :key="index"
            v-html="option.letter+'. '+option.content"
            :style="`font-size:${setFontSize}px !important;`"
          ></li>
        </ul>
    </div>
  </div>
</template>

<script>
// import affix from '@/components/affix/affix'
import { dataKatex } from "@/mixins/data-katex.js";
export default {
  name: "solution_question",
  data() {
    return {
      setFontSize: 20,
      question_type: "",
      affixShow: false,
      options: [
        {
          value: 18,
          label: '小'
        }, {
          value: 20,
          label: '标准'
        }, {
          value: 22,
          label: '大'
        }, {
          value: 24,
          label: '较大'
        }, {
          value: 26,
          label: '超大'
        }
      ]
    };
  },
  mixins: [dataKatex],
  components: {
    // affix
  },
  methods: {
    selectFontSize(val) {
      this.$root.eventHub.$emit('fontsize', val)
    },
    changeAffix(affixed) {
      this.affixShow = affixed
    },
    questionStem(stem, id) {
      if(stem.indexOf('【改错开始】') != -1 ) {
        let str = ''
        str = stem.replace(/【改错开始】/, `<div id="gaicuo-${id}" class="gaicuo">`)
        str = str.replace(/【改错结束】/, '</div>')
        return str
      } else {
        return stem
      }
    }
  },
  props: {
    question: {
      type: Object,
    },
    isComposite: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // let typeId = this.question.typeId;
    // let typeCode = this.question.typeCode;
    // if (typeId == 40) {
    //   this.question_type = "七选五";
    // }else if(typeId == 39){
    //   this.question_type = "改错题";
    // } else {
    //   if (typeCode == "A") {
    //     this.question_type = "单选题";
    //   }
    //   if (typeCode == "B") {
    //     this.question_type = "多选题";
    //   }
    //   if (typeCode == "C") {
    //     this.question_type = "判断题";
    //   }
    //   if (typeCode == "S") {
    //     this.question_type = "解答题";
    //   }
    //   if (typeCode == "M") {
    //     this.question_type = "复合题";
    //   }
    //   if (typeCode == "E") {
    //     this.question_type = "填空题";
    //   }
    // }

    this.$root.eventHub.$on('fontsize',(size) => {
      this.setFontSize = size
    })
  },
};
</script>

<style lang="scss" scoped>
/deep/ .gaicuo {
  padding: 30px;
  padding-top: 80px;
  padding-bottom: 100px;
}
.title {
  width: 1500px;
  background-color : #f5f5f5;
  position : relative;
   .question_type {
    width: 1400px;
    position: absolute;
    top: 12px;
    height : 60px;
    margin-left : 25px;
    // background-color : #ffffff;
    border-radius :  50px 50px 50px 50px;
    z-index: 10;
    .cricle{
      width: 60px;
      height: 60px;
      border-radius: 30px;
      border : 2px solid #dddddd;
      position : absolute;
      z-index : 0;
      margin : 0;
      padding : 0;
    }
    .mask{
      z-index :9;
      width: 30px;
      height: 60px;
      background-color : #ffffff;
      margin-left : 30px;
      position : absolute;
    }
    .id {
      z-index : 10;
      min-width: 47px;
      width: auto;
      height: 47px;
      border-radius: 47px;
      background-color: #7eb8ff;
      margin-top : 6.5px;
      color: #ffffff;
      font-size: 19px;
      line-height: 47px;
      text-align: center;
      position: absolute;
      float: left;
      margin-left : 6.5px;
    }

    .name {
      width: calc(100% - 105px);
      font-size: 24px;
      color: #ababab;
      position: absolute;
      float: left;
      margin-top: 10px;
      margin-left : 70px;
    }

    .score {
      margin-left: 95px;
    }

    .divs {
      float: right;
      margin-right: -95px;
      /deep/ .el-select {
        width: 120px;
        .el-input.is-focus .el-input__inner {
          border-color: #5c307d;
        }
        .el-input__inner {
          font-size: 16px;
        }
      }

      .text {
        font-size: 24px;
        color: #ababab;
        margin-top:8px; 
      }
    }
  }

  .question_content {
    border : 2px solid #dddddd;
    background-color : #ffffff;
    // width: 1496px;
    position : relative ;
    margin-left: 55px;
    min-height : 440px;
    overflow-y : auto;
    padding-bottom : 40px;
    .topic {
      position: relative;
      // width: 1400px;
      // margin-top: 80px;
      color: #3c3c3c;
      // float: left;
      line-height: 2.5;
      padding: 0 30px;
      display: inline-block;
      // max-height: 400px;
      // overflow: auto;
      /deep/ .text {
        font-family:'Times New Roman','Microsoft YaHei',SimHei;
        font: 'Times New Roman','Microsoft YaHei',SimHei;

        p{
          font-size : 18px ;
          word-break:break-word;
            overflow-wrap: break-word;
          span{
            word-break:break-word;
            overflow-wrap: break-word;
          }
        }
      }

      >>> img {
        vertical-align: middle;
      }
    }
    .options {
    margin-left: 110px;
    width: 100%;
    float: left;
    >>> .text {
      font-family:'Times New Roman','Microsoft YaHei',SimHei;
      font: 'Times New Roman','Microsoft YaHei',SimHei;
    }

    .option {
      position: relative;
      width: 1320px;
      margin-top: 10px;
      font-size: 18px;
      color: #3c3c3c;
      float: left;
      line-height: 1.5;
      margin-left: 15px;
      word-wrap: break-word;
    }
  }
  }
}
</style>